import $ from 'jquery'

$('body').addClass('state-loading')

$(window).on('load', function() {
  $('#js-loader').fadeOut(300)
  $('#js-shutter').addClass('js-appear')
  setTimeout(function() {
    $('#js-shutter')
      .hide()
      .removeClass('js-appear')
  }, 1000)
  $('body')
    .removeClass('state-loading')
    .addClass('state-loaded')
})
